import { createTheme } from '@material-ui/core';
import colorSet from './colorSet';

const theme = createTheme({
  typography: {
    fontFamily: ['Noto Sans KR', 'sans-serif'].join(','),
    h1: {
      fontSize: 40,
      lineHeight: '160%',
      letterSpacing: '-0.1px',
      fontWeight: 'normal'
    },
    h2: {
      fontSize: 32,
      lineHeight: '150%',
      letterSpacing: '-0.1px',
      fontWeight: 'normal'
    },
    h3: {
      fontSize: 25,
      lineHeight: '160%',
      letterSpacing: '-0.1px',
      fontWeight: 'normal'
    },
    h4: {
      fontSize: 20,
      lineHeight: '160%',
      letterSpacing: '-0.1px',
      fontWeight: 'normal'
    },
    body1: {
      fontSize: 16,
      lineHeight: '150%',
      letterSpacing: '-0.1px',
      fontWeight: 'normal'
    },
    body2: {
      fontSize: 14,
      lineHeight: '143%',
      letterSpacing: '-0.1px',
      fontWeight: 'normal'
    },
    subtitle1: {
      fontSize: 18,
      lineHeight: '130%',
      letterSpacing: '-0.1px',
      fontWeight: 'normal'
    },
    subtitle2: {
      fontSize: 13,
      lineHeight: '140%',
      letterSpacing: '-0.1px',
      fontWeight: 'normal'
    },
    caption: {
      fontSize: 12,
      lineHeight: '150%',
      letterSpacing: '-0.1px',
      fontWeight: 'normal'
    }
  },
  palette: {
    primary: {
      light: colorSet.primary100,
      main: colorSet.primary500,
      dark: colorSet.primary600,
      contrastText: colorSet.gray000
    },
    secondary: {
      light: colorSet.gray100,
      main: colorSet.gray300,
      dark: colorSet.gray400,
      contrastText: colorSet.gray700
    },
    error: {
      light: colorSet.errorLight,
      main: colorSet.errorMain,
      dark: colorSet.errorDark,
      contrastText: colorSet.gray000
    },
    warning: {
      light: colorSet.warningLight,
      main: colorSet.warningMain,
      dark: colorSet.warningDark,
      contrastText: colorSet.gray000
    },
    success: {
      light: colorSet.successLight,
      main: colorSet.successMain,
      dark: colorSet.successDark,
      contrastText: colorSet.gray000
    },
    text: {
      primary: colorSet.gray900,
      secondary: colorSet.gray700,
      disabled: colorSet.gray500
    }
  },
  shadows: [
    'none',
    '0px 2px 4px -1px rgba(0, 0, 0, 0.1), 0px 4px 5px rgba(0, 0, 0, 0.07), 0px 1px 10px rgba(0, 0, 0, 0.06)',
    '0px 5px 5px -3px rgba(0, 0, 0, 0.1), 0px 8px 10px 1px rgba(0, 0, 0, 0.07), 0px 3px 14px 2px rgba(0, 0, 0, 0.06)',
    '0px 8px 16px 2px rgba(97, 97, 97, 0.1), 0px 16px 32px 2px rgba(97, 97, 97, 0.1)',
    '0px 24px 48px 10px rgba(97, 97, 97, 0.06), 0px 32px 64px 10px rgba(0, 0, 0, 0.06)',
    '0px 24px 24px -6px rgba(0, 0, 0, 0.2), 0px 24px 56px 4px rgba(0, 0, 0, 0.14), 0px 14px 56px 7px rgba(0, 0, 0, 0.12)',
    '0px 26px 36px -4px rgba(0, 0, 0, 0.2), 0px 36px 72px 5px rgba(0, 0, 0, 0.14), 0px 16px 64px 8px rgba(0, 0, 0, 0.12)',
    '0px 2px 4px -1px rgba(7, 59, 100, 0.2), 0px 4px 5px rgba(7, 59, 100, 0.14), 0px 1px 10px rgba(7, 59, 100, 0.12)',
    '0px 5px 5px -3px rgba(7, 59, 100, 0.2), 0px 8px 10px 1px rgba(7, 59, 100, 0.14), 0px 3px 14px 2px rgba(7, 59, 100, 0.12)',
    '0px 7px 8px -4px rgba(7, 59, 100, 0.4), 0px 12px 17px 2px rgba(7, 59, 100, 0.28), 0px 5px 22px 4px rgba(7, 59, 100, 0.24)',
    '0px 8px 10px -5px rgba(7, 59, 100, 0.4), 0px 16px 24px 2px rgba(7, 59, 100, 0.28), 0px 6px 30px 5px rgba(7, 59, 100, 0.24)',
    '0px 24px 24px -6px rgba(7, 59, 100, 0.4), 0px 24px 56px 4px rgba(7, 59, 100, 0.28), 0px 14px 56px 7px rgba(7, 59, 100, 0.24)',
    '0px 26px 36px -4px rgba(7, 59, 100, 0.4), 0px 36px 72px 5px rgba(7, 59, 100, 0.28), 0px 16px 64px 8px rgba(7, 59, 100, 0.24)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)'
  ],
  overrides: {
    MuiDialog: {
      paperFullWidth: {
        width: `calc(100% - 32px)`,
        margin: 16
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: '8px',
        '&:hover': {
          '& fieldset, .MuiOutlinedInput-notchedOutline': {
            borderColor: colorSet.gray700
          }
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: colorSet.gray400
        },
        '&.Mui-disabled': {
          backgroundColor: colorSet.gray100,
          color: colorSet.gray500,
          '& fieldset, .MuiOutlinedInput-notchedOutline': {
            borderColor: colorSet.gray400
          },
          '&:hover fieldset, .MuiOutlinedInput-notchedOutline': {
            borderColor: colorSet.gray400
          },
          '&.MuiOutlinedInput-adornedStart, .MuiOutlinedInput-adornedEnd': {
            color: colorSet.gray700
          }
        },
        '&.Mui-focused': {
          '& fieldset, .MuiOutlinedInput-notchedOutline': {
            borderColor: colorSet.gray900,
            borderWidth: '2px'
          }
        }
      }
    },
    MuiTextField: {
      root: {
        '& .MuiOutlinedInput-root': {
          height: (el: any) =>
            el.style?.height
              ? el.style?.height
              : el.multiline
              ? 'auto'
              : el.size === 'small'
              ? '40px'
              : el.size === 'medium'
              ? '48px'
              : 'auto',
          '&.MuiOutlinedInput-multiline': {
            padding: '8px 12px',
            '& .MuiOutlinedInput-inputMultiline': {
              padding: '0px',
              marginRight: '0px'
            }
          },
          '&.MuiOutlinedInput-adornedStart, .MuiOutlinedInput-adornedEnd': {
            fontSize: (el: any) => (el.size === 'small' ? 14 : 16),
            lineHeight: (el: any) => (el.size === 'small' ? '143%' : '150px')
          },
          '&.MuiOutlinedInput-adornedStart': {
            paddingLeft: '12px'
          },
          '&.MuiOutlinedInput-adornedEnd': {
            paddingRight: '12px',
            '& .MuiIconButton-root': {
              padding: 6
            },
            '& svg': {
              width: (el: any) => (el.size === 'small' ? '20px' : '24px'),
              height: (el: any) => (el.size === 'small' ? '20px' : '24px')
            }
          },
          '& .MuiOutlinedInput-input': {
            fontSize: (el: any) => (el.size === 'small' ? 14 : 16),
            lineHeight: (el: any) => (el.size === 'small' ? '143%' : '150%'),
            padding: (el: any) => (el.size === 'small' ? '10px 12px' : '12px'),
            paddingRight: (el: any) => {
              return el.endAdornment !== undefined ||
                el.InputProps?.endAdornment !== undefined
                ? '4px'
                : '12px';
            },
            paddingLeft: (el: any) =>
              el.startAdornment !== undefined ||
              el.InputProps?.startAdornment !== undefined
                ? '4px'
                : '12px'
          }
        },
        '& .MuiFormHelperText-root': {
          textAlign: 'right',
          margin: '0px 4px 0px',
          position: 'absolute',
          bottom: -18,
          right: 0,
          '&.Mui-error': {
            textAlign: 'right'
          }
        }
      }
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  }
});

export default theme;
